import React from "react";

import {
  formatDate,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import {  FiEye, FiTrash } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { removeCareplanById } from "../../services/CreateCarePlanService";
import { useState } from "react";
import DeleteModal from "../../commonComponent/DeleteModal";

const MyPatientCarePlanList = ({ list, userId, onComplete }) => {
  const navigate = useNavigate();
  const [careplanId, setCarePlanId] = useState()
  const removeCareplanHandler = async (id) => {
    let params = {};
    params["careplanId"] = id;
    params["userId"] = userId;
    console.log(params);
    try {
      const response = await removeCareplanById(params);
      if (response?.data?.status === 200) {
        showToastSuccess("Careplan Removed");
        onComplete();
        console.log(response);
      } else {
        showToastError("Error Occured");
      }
    } catch (error) {
      showToastError(error || "Error Occured from catch");
    }
  };

  return (
    <>
      <DeleteModal
        title={"Remove"}
        content1={"Are you sure you want to Remove"}
        content2={"this Care plan?"}
        modalId={"removeCareplan"}
        button2={"No"}
        button1={"Yes"}
        onDelete={() => removeCareplanHandler(careplanId)}
      />
      {list?.map((item) => (
        <div
          key={item._id}
          className="mypatient_activeprogram7 w-100 shadow-sm rounded card px-3 py-4 mx-0"
        >
          <div className="d-flex justify-content-between ">
            <div className="w-75">
              <h5>{item.name}</h5>
              <p className="fw-light">{item.description}</p>
            </div>
            <div className="">
              <button
                className="btn btn-light me-2"
                onClick={() =>
                  navigate("/careplanedit", { state: { careplan: item } })
                }
              >
                <FiEye />
              </button>
              {/* <button className="btn btn-light me-2">
                <FiEdit />
              </button> */}
              <button
                data-bs-toggle="modal"
                data-bs-target="#removeCareplan"
                className="btn btn-light me-2"
                onClick={() => {
                  setCarePlanId(item._id)
                }}
              >
                <FiTrash />
              </button>
            </div>
          </div>
          <div className="table_resouter card bg-light p-2">
            <table class="table table-borderless table_resinner mb-0">
              <tbody>
                <tr style={{ lineHeight: "15px" }}>
                  <td>
                    Assign Date:
                    <span className="mypatcplan">
                      {" "}
                      {formatDate(item.assignDate)}
                    </span>
                  </td>
                  <td colSpan="2">
                    Duration:
                    <span className="mypatcplan"> {item.duration}</span>
                  </td>
                </tr>
                {/* <tr style={{ lineHeight: "15px" }}>
                  <td colSpan="3">
                    Goal :
                    <span className="mypatcplan">
                      Aggressive blood pressure control to target values
                      130/80
                    </span>
                  </td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </>
  );
};

export default MyPatientCarePlanList;
